"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberingSelector = exports.Numberings = exports.Numbering = exports.InvoiceNumbering = void 0;
const InvoiceNumbering_yaml_component_1 = __importDefault(require("./InvoiceNumbering.yaml?component"));
exports.InvoiceNumbering = InvoiceNumbering_yaml_component_1.default;
const Numbering_yaml_component_1 = __importDefault(require("./Numbering.yaml?component"));
exports.Numbering = Numbering_yaml_component_1.default;
const Numberings_yaml_component_1 = __importDefault(require("./Numberings.yaml?component"));
exports.Numberings = Numberings_yaml_component_1.default;
const NumberingSelector_yaml_component_1 = __importDefault(require("./NumberingSelector.yaml?component"));
exports.NumberingSelector = NumberingSelector_yaml_component_1.default;
